import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=2b7aa0f2&scoped=true"
import script from "./cart.js?vue&type=script&lang=js&external"
export * from "./cart.js?vue&type=script&lang=js&external"
import style0 from "./cart.scss?vue&type=style&index=0&id=2b7aa0f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7aa0f2",
  null
  
)

export default component.exports